import React from 'react'
import { fieldToTextField, TextFieldProps } from 'formik-material-ui'
import StyledOutlinedTextFieldComponent from './StyledOutlinedTextFieldComponent'

export default function StyledOutlinedTextField(props: TextFieldProps): JSX.Element {
  return <StyledOutlinedTextFieldComponent {...fieldToTextField(props)} />
}
